import React from "react";

const WeightBody = () => {
  return (
    <div>
      <h2>Weight Body Content</h2>
    </div>
  );
};

export default WeightBody;
